import { ref, isRef, computed } from '@vue/composition-api';
import { isEqual } from 'lodash-es';

export function useObjectWithChangeDetection (obj) {
  const changes = ref({});
  const object = computed(() => {
    const unwrappedTarget = isRef(obj) ? obj.value : obj;
    const getHandler = (target, key) => {
      // prevent Vue to define reactive property on the object to be tracked
      // this guarantee reactivity for fields that are not present in the original object to be tracked in changes
      if (key === '__ob__') return undefined;
      return key in changes.value ? changes.value[key] : target[key];
    };
    return unwrappedTarget && new Proxy(unwrappedTarget, {
      has: getHandler,
      get: getHandler,
      set (target, key, value) {
        const dirty = !isEqual(target[key], value);
        if (dirty) {
          changes.value = { ...changes.value, [key]: value };
        } else {
          const clone = { ...changes.value };
          delete clone[key];
          changes.value = clone;
        }
        return true;
      },
    });
  });
  return {
    changes,
    isDirty: computed(() => Object.entries(changes.value).length > 0),
    object,
  };
}
